import React from 'react';

const YouTubeBlock = ({ block, onChange }) => {
  return (
    <div>
      <input
        type="text"
        placeholder="Paste YouTube video URL"
        value={block.url || ''}
        onChange={(e) => onChange({ ...block, url: e.target.value })}
        style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
      />
    </div>
  );
};

export default YouTubeBlock;
